<template>
  <v-container fluid>
    <v-row align="center">
      <v-col cols="auto" class="text-h3 gray--text">
        Resumo Geral
      </v-col>

      <v-col cols="auto">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              small
              v-on="on"
              :attrs="attrs"
              :to="`/pacientes/${attendance.patient.id}`"
            >
              <v-icon>eva-file-outline</v-icon>
            </v-btn>
          </template>
          <span>Histórico</span>
        </v-tooltip>
      </v-col>

      <v-col cols="auto">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              :disabled="false"
              :loading="printLoading"
              @click="printExcimerLaser"
              :attrs="attrs"
              v-on="on"
            >
              <v-icon> ri-article-line</v-icon>
            </v-btn>
          </template>
          <span> Imprimir Excimer Laser </span>
        </v-tooltip>
      </v-col>

      <v-col cols="auto">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              :disabled="false"
              :loading="printLoading"
              @click="printOccupationalExam"
              :attrs="attrs"
              v-on="on"
            >
              <v-icon> eva-printer-outline </v-icon>
            </v-btn>
          </template>
          <span> Imprimir Exame Ocupacional </span>
        </v-tooltip>
      </v-col>

      <v-spacer />

      <v-col cols="auto">
        <AttendanceEsign :attendance="attendance" v-if="attendance" />
      </v-col>
    </v-row>

    <Sumary :attendance="attendance" v-if="attendance" />
  </v-container>
</template>

<script>
import AttendanceEsign from "@/components/attendance/attendance_esign.vue";
import Sumary from "@/components/sumary/index.vue";
import SAVE_EXCIMER_LASER from "@/graphql/excimer_laser/save_excimer_laser.gql";
import SAVE_OCCUPATIONAL_EXAM from "@/graphql/occupational_exam/save_occupational_exam.gql";

export default {
  name: "SumaryView",
  props: {
    attendance: Object,
  },
  components: {
    AttendanceEsign,
    Sumary,
  },
  data() {
    return {
      printLoading: false,
    };
  },
  apollo: {
    excimerLaser: {
      query: require("@/graphql/excimer_laser/excimer_laser.gql"),
      variables() {
        return {
          attendanceId: this.attendance.id,
        };
      },
      result({ data }) {
        this.excimerLaserId = data.excimerLaser?.id;
      },
    },
    occupationalExam: {
      query: require("@/graphql/occupational_exam/occupational_exam.gql"),
      variables() {
        return {
          attendanceId: this.attendance.id,
        };
      },
      result({ data }) {
        this.occupationalExamId  = data.occupationalExam?.id;
      },
    },
  },
  methods: {
    async refreshExcimerLaser() {
      await this.$apollo.queries.excimerLaser.refetch();
    },
    async refreshOccupationalExam() {
      await this.$apollo.queries.occupationalExam.refetch();
    },
    async printExcimerLaser() {
      await this.saveExcimerLaser();
      await this.refreshExcimerLaser();
      await this.downloadExcimerLaser();
    },
    async printOccupationalExam() {
      await this.saveOccupationalExam();
      await this.refreshOccupationalExam();
      await this.downloadOccupationalExam();
    },
    async saveExcimerLaser() {
      const { data } = await this.apolloMutate({
        mutation: SAVE_EXCIMER_LASER,
        variables: {
          attendanceId: this.attendance.id,
          excimerLaserId: this.excimerLaserId,
        },
      });
      this.excimerLaserId = data.saveExcimerLaser.id;
    },

    async saveOccupationalExam() {
      const { data } = await this.apolloMutate({
        mutation: SAVE_OCCUPATIONAL_EXAM,
        variables: {
          attendanceId: this.attendance.id,
          occupationalExamId: this.occupationalExamId,
        },
      });
      this.occupationalExamId = data.saveOccupationalExam.id;
    },
    async generateExcimerLaserPreview() {
      await this.apolloMutate({
        mutation: require("@/graphql/esign/generate_preview.gql"),
        variables: {
          esignId: this.excimerLaser.lastEsign.id,
        },
      });
    },
    async generateOccupationalExamPreview() {
      await this.apolloMutate({
        mutation: require("@/graphql/esign/generate_preview.gql"),
        variables: {
          esignId: this.occupationalExam.lastEsign.id,
        },
      });
    },
    async openPdfInNewTab(url) {
      await window.open(`${process.env.VUE_APP_BASE_URL}${url}`, "_blank");
    },
    async downloadExcimerLaser() {
      this.printLoading = true;
      await this.generateExcimerLaserPreview();
      await this.refreshExcimerLaser();
      const pdfUrl = this.excimerLaser.lastEsign.fileUrl;

      await this.openPdfInNewTab(pdfUrl);

      this.printLoading = false;
    },
    async downloadOccupationalExam() {
      this.printLoading = true;
      await this.generateOccupationalExamPreview();
      await this.refreshOccupationalExam();
      const pdfUrl = this.occupationalExam.lastEsign.fileUrl;

      await this.openPdfInNewTab(pdfUrl);

      this.printLoading = false;
    },
  },
};
</script>

<style lang="scss" scoped></style>
